import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolService } from "../../../../../shared/services/school.service";
import { DistrictCalendarSchoolTableComponent } from "../shared/district-calendar-school-table/district-calendar-school-table.component";
import { CalendarHolidayInsertRequest } from "../shared/calendar-holiday-insert-request";
import * as moment from "moment";
import { DistrictAdministrationService } from "../../../services/districtadministration.service";

@Component({
	selector: "app-district-add-holiday",
	templateUrl: "./district-add-holiday.component.html",
	styleUrls: ["./district-add-holiday.component.css"],
})
export class DistrictAddHolidayComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private schoolService: SchoolService,
		private districtService: DistrictAdministrationService
	) {}

	ngOnInit(): void {
		this.loadSchools();
	}

	////////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////////

	EntryDate: Date = new Date();

	IsOpenID: number = 0;
	lstIsOpen: any = [
		{
			ID: 0,
			Desc: "Closed",
		},
		{
			ID: 1,
			Desc: "Open on Weekend",
		},
	];

	AllSchools: boolean = true;
	lstSchool: any = [];
	SchoolLoading: boolean = false;

	@ViewChild(DistrictCalendarSchoolTableComponent)
	tableRef: DistrictCalendarSchoolTableComponent;

	Processing: boolean = false;
	errorMessage: string = "";

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////////////////////

	loadSchools() {
		this.SchoolLoading = true;

		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				this.SchoolLoading = false;
			},
			(error) => {
				this.SchoolLoading = false;
			}
		);
	}

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////////////

	onAdd() {
		var fsDate = moment(this.EntryDate).format("MM/DD/YYYY");
		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Date";
			return;
		}

		var lstSID: number[] = [];

		if (this.AllSchools == false) {
			lstSID = this.tableRef.SelectedSchools.map((school) => school.SchoolID);

			if (lstSID.length == 0) {
				this.errorMessage = "Select Schools to Update";
				return;
			}
		}

		var parms: CalendarHolidayInsertRequest = {
			CalendarDate: fsDate,
			IsOpen: this.IsOpenID,
			AllSchools: this.AllSchools == true ? 1 : 0,
			lstSchoolID: lstSID,
		};

		this.Processing = true;

		var result = this.districtService.CalendarHolidayInsert(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "addholiday",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Calendar was updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "addholiday",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update calendar: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.SchoolLoading == true || this.Processing == true;
	}

	////////////////////////////////////////////////////////////////////////
}
